import React from 'react'
import PropTypes from "prop-types"
import moment from 'moment'
import { connect } from 'react-redux'
import { values, isNumber, sortBy, debounce } from 'lodash'
import { DateTimePicker } from 'react-widgets'
import { Link } from 'react-router'
import Markdown from 'react-markdown'
import Json from 'react-json-view'

import {  Form, FormGroup, ControlLabel, FormControl, ButtonGroup, Modal } from 'react-bootstrap'

import { str2date, date2str, printMoney, linkifyMarkdown, randstr } from 'Lib/Tools'

import { getAllActivities, getAllCities, getSuppliers } from '../selectors'
import { getText, nameOrTitle, translateCity } from '../lib/text'
import { getIva, getBI } from './ReservationTools'

import VisualPrice from '../components/VisualPrice'
import Button from '../components/Button'
import ReservationDetails from './ReservationDetails'
import SupplierModal from './SupplierModal'

import "./Reservation.less"
import EditTimeModal from './components/EditTimeModal';
import { addNote } from '../ducks/routes';

import { updateReservation } from '../ducks/reservations.js'

const reservationColor = { sr: "white", nn: "#e6f2ff", res: "#b3e6cc", pag: "#ffd699", wtf: "#ff9999" }

class Reservation extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      modal: null, // "details" | "supplier"
      txId: `rtx-${randstr()}`
    }

    this.boundOnChange = this.onChange.bind(this)
    this.debGrowTextarea = debounce(this.growTextarea.bind(this), 50, { trailing: true })
    
    this.tx = null // the textarea
  }

  modal(modal) {
    this.setState({ modal })
  }

  onChange(changes) {
    this.props.onChange(this.props.reservation._id, this.props.billItem, changes)
  }
  
  growTextarea() {
    // tried doing this, but tx has no .style
    // const tx = this.textAreaRef.current
    
    const tx = this.tx || document.getElementById(this.state.txId)
    if (tx) {
      this.txt = tx
      const sh = tx.scrollHeight
      // tx.setAttribute('style', `height:${tx.scrollHeight}px; overflow-y:hidden; max-height: 232px`);
      tx.style.height = `auto` // hace falta porque si no scrollheight sigue siendo 100%
      tx.style.height = `${Math.min(tx.scrollHeight + 3, 300)}px`
      tx.style.overflowY = sh > 300 ? "scroll" : "hidden"
    }
    else {
      window.requestAnimationFrame(this.debGrowTextarea)
    } 
  }

  componentDidMount() {
    this.debGrowTextarea()
  }
  
  componentDidUpdate(prevProps) {
    if (prevProps.reservation.notes != this.props.reservation.notes) {
      this.debGrowTextarea()      
    }
  }

  render() {
    const { props } = this
    const { error, suppliers, Cities, trip, billItem, route } = props
    const r = props.reservation

    // #TODO remove this way of setting the default supplier. it sucks.
    const activity = props.Activities[r.activityId]
    const defaultSupplier = r.type == "activity" && r.activityId && suppliers[activity.supplier]
    const supplier = suppliers[r.supplier]
    const reserved = r && r.status != "sr" && r.status != "nn"

    const finalPrice = (r.finalPrice || 0)
    const estimated = !r.baseImponible && r.finalPrice

    const note = billItem ? billItem.innerNote : null

    return (
      <tr
        style={error ? {} : { backgroundColor: reservationColor[r.status] }}
        className={`reservation ${(error ? "errorStripes" : r.status)}`}
      >
        { /* _item, _fecha, _horario */ }
        <td className="title">
          {
            trip && props.includeTrip && (
              <Link
                to={`/private/trip/${encodeURIComponent(r.tripId)}?tab=6`}
                style={{ fontWeight: "bold", fontStyle: "italic" }}
              >
                {trip.name || "Sin nombre"} - {trip.realName || "Sin pinyin"}<br />
              </Link>
            )
          }
          {
            r.type == "activity"
              ? (
                <Link to={`/private/activity/${encodeURIComponent(r.activityId)}?`}>
                  {nameOrTitle(r)}
                </Link>
              )
              : <span className="noLink">{nameOrTitle(r)}</span>
          }
          {
            r.city && (
              <span className="noLink"> ({translateCity(Cities[r.city])})</span>
            )
          }
          <br />
          {/* #TODO fix repetitionDates for referencer-expenses */}
          Fecha: {r.repetitionDates ? r.repetitionDates.join(", ") : r.date}
          <br />
          Horario: {r.time || "-"}
          <Button 
            glyph="pencil"
            bsSize="xsmall"
            className="editTimeButton"
            onClick={() => this.setState({ editingTimeItemKey: r.itemKey })}
            tooltipText="Editar horario"
          />
          <div className="modification">
            Ult. mod: {moment(r.modification).format('YYYY-MM-DD HH:mm:ss')}
          </div>
          {
            this.state.editingTimeItemKey && (
              <EditTimeModal
                reservationId={r._id}
                itemKey={r.itemKey}
                route={route}
                onClose={() => this.setState({ editingTimeItemKey: null })}
              />
            )
          }
          <br />
          {
            note && (
              <div>
                <strong>Nota:</strong>
                <Markdown source={linkifyMarkdown(note)} className="small-reservation-note"/>
              </div>
            )
          }

          {/*
          <button onClick={() => this.setState({jsonModal: true})}>json</button>
          */}

          {
            this.state.jsonModal && (
              <Modal show onHide={() => this.setState({ jsonModal: false })}>
                <Modal.Header>
                  <Modal.Title>BillItem:</Modal.Title>
                  <button onClick={() => this.setState({ jsonModal: false })}>close</button>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "60vh", overflow: "scroll" }}>
                  <Json src={billItem} />
                </Modal.Body>
              </Modal>
            )
          }
        </td>

        { /* _error, _button, _status, _proveedor, _supplier */ }
        <td className="status">

          {
            error && (
              <div className="error">
                {`⚠️  ${getText("Error (ver arriba)")} ⚠️ `}
              </div>
            )
          }

          <ButtonGroup className="botoneraDesglose">
            {
              [
                { bsStyle: "default", text: "S.R.", status: "sr",  tooltipText: "Sin reservar" },
                { bsStyle: "info",    text: "N.N.", status: "nn",  tooltipText: "No necesita" },
                { bsStyle: "success", text: "Res.", status: "res", tooltipText: "Reservado" },
                { bsStyle: "warning", text: "Pag.", status: "pag", tooltipText: "Pagado" },
                { bsStyle: "danger",  text: "WTF!", status: "wtf", tooltipText: "Problema" },
              ]
                .map(({ status, bsStyle, text, tooltipText }) => (
                  <Button
                    active={r && r.status ? r.status == status : status == "sr"}
                    key={text}
                    bsStyle={bsStyle}
                    tooltipText={tooltipText}
                    disabled={error}
                    onClick={() => r.status != status && this.boundOnChange({
                      status,
                      finalPrice : (status == "sr" || status == "nn") ? 0 : r.finalPrice,
                      baseImponible : (status == "sr" || status == "nn") ? 0 : r.baseImponible
                    })}
                  >
                    {text}
                  </Button>
                ))
            }
          </ButtonGroup>

          <br />

          {
            r.status != "nn" && (
              <Form inline>
                <FormGroup>
                  <FormControl
                    className="supplierSelect"
                    componentClass="select"
                    bsSize="xsmall"
                    value={r.supplier}
                    onChange={evt => this.boundOnChange({ supplier: evt.target.value == "" ? null : evt.target.value })}
                  >
                    <option value={""} >{`${getText("Sin proveedor")}`}</option>
                    {
                      defaultSupplier && (
                        <option key={defaultSupplier._id} value={defaultSupplier._id}>{defaultSupplier.name}</option>
                      )
                    }
                    <option disabled >──────────</option>
                    {
                      sortBy(values(suppliers), o => o.name.toLowerCase())
                        .map(s => <option key={s._id} value={s._id}>{s.name}</option>)
                    }
                  </FormControl>
                  {
                    supplier && (
                      <Link to={`/private/supplier/${supplier._id}`}>
                        <Button glyph="share-alt" bsSize="xsmall" tooltipText="Ver proveedor" />
                      </Link>
                    )
                  }
                </FormGroup>
                {
                  suppliers[r.supplier] && (
                    <div>
                      {
                        supplier.reservationsNotes && (
                          <div className="reservations-notes">
                            Instrucciones: <Markdown source={supplier.reservationsNotes} />
                          </div>
                        )
                      }
                      {
                        (supplier.enableReservationsPhone || supplier.enableReservationsEmail)
                        && (
                          <div>
                            <div>
                              {
                                supplier.enableReservationsPhone
                                && (supplier.useReservationsPhone ? supplier.reservationsPhone : supplier.phoneNumber)
                              }
                              <span> - </span>
                              {
                                supplier.enableReservationsEmail
                                && (supplier.useReservationsEmail ? supplier.reservationsEmail : supplier.email)
                              }
                            </div>
                            <Button bsSize="small" onClick={() => this.modal("supplier")}>
                              {supplier.enableReservationsEmail && "✉️ "}
                              {supplier.enableReservationsPhone && "📞 "}
                              Contactar
                            </Button>
                          </div>
                        )
                      }
                    </div>
                  )
                }
              </Form>
            )
          }
        </td>

        { /* _estimado */ }
        <td className="estimado">

          {
            billItem && (
              <div>
                <VisualPrice
                  billItem={billItem}
                  agendaItem={billItem.agendaItem}
                  Activities={props.Activities}
                  referencedExpense={billItem.referencedAgendaItem && billItem.referencedAgendaItem.expense}
                />
              </div>
            )
          }

        </td>

        { /* _finalPriceNoIVA */ }
        <td className="final">
          <FormControl
            bsSize = "small"
            style={{ fontStyle: estimated ? "italic" : "normal" }}
            value={
              /* There is redundance (getBI already checks r.baseImponible)        *
               * because otherwise with toFixed the field can't be edited properly */
              r.baseImponible ? r.baseImponible : getBI(r).toFixed(2)
            }
            type="number"
            disabled={!reserved || error}
            onChange={evt => {
              // #TODO allow 0, or allow to delete the last digit
              const eur = Number.parseFloat(evt.target.value || 0) || 0
              if (isNumber(eur) && eur >= 0) {
                this.boundOnChange({ baseImponible: eur, isBaseEdited: true })
              }
            }}
          />
          {
            estimated && reserved && (
              <div className="estimated">
                <span>{`BI estimada al ${getIva(r)}%`}</span>
                <Button
                  glyph="ok"
                  bsSize="xsmall"
                  onClick={() => this.boundOnChange({ baseImponible: getBI(r).toFixed(2), isBaseEdited: true })}
                />
              </div>
            )
          }
          <div>
            <Button
              className="desgloseDetails"
              onClick={() => this.modal("details")}
              disabled={!reserved || error}
              label="Detalles"
            />
          </div>
        </td>
        { /* _finalPrice, _pordía */ }
        <td className="perday">
          <FormControl
            bsSize = "small"
            value={finalPrice}
            type="number"
            disabled={!reserved || error}
            onChange={evt => {
              // #TODO allow 0, or allow to delete the last digit
              const eur = Number.parseFloat(evt.target.value || 0) || 0
              if (isNumber(eur) && eur >= 0) {
                this.boundOnChange({ finalPrice: eur })
              }
            }}
          />
          {
            r.numRepetitions && r.numRepetitions > 1 && (
              <div>({printMoney(finalPrice / r.numRepetitions)} € / día)</div>
            )
          }
        </td>

        { /* _notas */ }
        <td className="notes">
          <div className="groupNote">
            <FormControl
              id={this.state.txId}
              componentClass="textarea"
              value={(r && r.notes) || ""}
              disabled={error}
              placeholder="Nota"
              onChange={evt => {
                this.boundOnChange({ notes: evt.target.value })
              }}
              
            />
            {
              r.notes && (
                <Button 
                  className="addNote"
                  glyph= "share-alt"
                  tooltipText="Envía esta nota a la ruta"
                  onClick={() => { this.props.addNote() }}
                />
              )
            }
          </div>
          <Form inline>
            <FormGroup>
              <ControlLabel>Nº Factura:</ControlLabel>
              <FormControl
                bsSize="small"
                value={r.receipt}
                className="nfactura"
                type="text"
                disabled={!reserved || error}
                onChange={evt => this.boundOnChange({ receipt: evt.target.value })}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>{getText("Fecha factura")}:</ControlLabel>
              <DateTimePicker
                calendar
                time={false}
                className="ffactura"
                format="YYYY/MM/DD"
                disabled={!reserved || error}
                value={r.receiptDate ? str2date(r.receiptDate) : null}
                defaultCurrentDate={str2date(r.receiptDate || moment().format("YYYY/MM/DD"))}
                onChange={d => this.boundOnChange({ receiptDate: date2str(d) }) }
              />
            </FormGroup>
          </Form>
        </td>

        {
          this.state.modal == "supplier" && (
            <SupplierModal
              {...{ trip, supplier, activity, reservation: r }}
              onClose={() => this.modal(null)}
            />
          )
        }

        {
          this.state.modal == "details" && (
            <ReservationDetails
              r={props.reservation}
              onChange={changes => this.boundOnChange(changes)}
              onClose={() => this.modal(null)}
            />
          )
        }
      </tr>
    )
  }
}

Reservation.propTypes = {
  // from daddy
  reservation: PropTypes.object.isRequired, // Object,
  error: PropTypes.bool.isRequired, // boolean,
  onChange: PropTypes.func.isRequired, // (string, Object, Object) => void,
  trip: PropTypes.object, // ?Object,
  includeTrip: PropTypes.bool.isRequired, // boolean,

  // connected
  Activities: PropTypes.object.isRequired, // Object,
  Cities: PropTypes.object.isRequired, // Object,
  suppliers: PropTypes.object.isRequired, // Object,

  billItem: PropTypes.object, // ?Object,
  jsonModal: PropTypes.bool.isRequired // false,
}

const mapStateToProps = (state, props) => ({
  Activities: getAllActivities(state, props),
  Cities: getAllCities(state, props),
  suppliers: getSuppliers(state, props)
})

const mapDispatchToProps = (dispatch, props) => ({
  addNote: () => {
    
    const { route, reservation } = props
    const itarget = route.agenda.findIndex(item => item.key == reservation.itemKey)
    dispatch(addNote(props.route._id, itarget + 1, reservation.notes + " - Enviado desde reservas (gema)"))
    dispatch(updateReservation(reservation._id, { notes: "" }))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(Reservation)
